var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3749 26.25H4.625C3.72751 26.25 3 25.5224 3 24.625C3 23.7276 3.72751 23 4.625 23H17.3749C18.2724 23 18.9999 23.7276 18.9999 24.625C18.9999 25.5224 18.2724 26.25 17.3749 26.25Z",
    fill: "#717579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3749 18.125H4.625C3.72751 18.125 3 17.3974 3 16.5C3 15.6026 3.72751 14.875 4.625 14.875H27.3749C28.2724 14.875 28.9999 15.6025 28.9999 16.5C28.9999 17.3975 28.2724 18.125 27.3749 18.125Z",
    fill: "#717579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3749 10H4.625C3.72751 10 3 9.2725 3 8.375C3 7.47751 3.72751 6.75 4.625 6.75H27.3749C28.2724 6.75 28.9999 7.47751 28.9999 8.375C28.9999 9.2725 28.2724 10 27.3749 10Z",
    fill: "#717579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.e62eaf82618b26ab87ec53c8a81a29e4.svg";
export { ForwardRef as ReactComponent };